import { Button, Typography, Stack } from '@mui/material'

import { MESSAGES } from '@/constants/messages'

import ChargingPointScreenTemplate from './template/ChargingPointScreenTemplate'
import { ChargingPointScreenProps } from './types'

import ChargingSessionBody from '../components/ChargingSessionBody'

const FinishingChargingSessionScreen: React.FC<ChargingPointScreenProps> = (props) => {
  return (
    <ChargingPointScreenTemplate
      {...props}
      Body={
        <ChargingSessionBody
          message={
            <Stack direction="column" spacing={0.5} alignItems="center">
              <Typography variant="subtitle2" textAlign="center" fontWeight="bold">
                {MESSAGES.CHARGING_SESSION.FINISHING_SESSION_TITLE}
              </Typography>
              <Typography variant="caption" textAlign="center" color="text.secondary">
                {MESSAGES.CHARGING_SESSION.FINISHING_SESSION_SUBTITLE}
              </Typography>
            </Stack>
          }
        />
      }
      Footer={
        <Button
          color="primary"
          variant="contained"
          sx={{ width: '100%', borderRadius: 4 }}
          loading={true}
          disableElevation
        >
          Finalizar carregamento
        </Button>
      }
    />
  )
}

export default FinishingChargingSessionScreen
